<template>
  <form @submit.prevent="submit">

    <!-- ══ NON CONFORMITÉ ══════════════════════════════════════════ -->
    <div class="section-header">NON CONFORMITÉ</div>

    <v-row class="mt-3">
      <v-col cols="12" md="6">
        <div class="field-label">DATE*</div>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          light
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-if="mode !== 'visualisation'"
              :value="formatDate"
              dense
              readonly
              outlined
              hide-details
              prepend-inner-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
            />
            <div v-else class="view-value">{{ formatDate }}</div>
          </template>
          <v-date-picker v-model="supplierQuality.date" no-title locale="fr-fr" @input="menu = false" />
        </v-menu>
        <div class="error-msg" v-if="$v.supplierQuality.date.$error">Renseignez la date</div>
      </v-col>

      <v-col cols="12" md="6">
        <div class="field-label">FOURNISSEUR*</div>
        <v-text-field
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.supplier"
          maxLength="200"
          outlined
          dense
          hide-details
        />
        <div v-else class="view-value">{{ supplierQuality.supplier }}</div>
        <div class="error-msg" v-if="$v.supplierQuality.supplier.$error">Renseignez le fournisseur</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <div class="field-label">N° DE NON CONFORMITÉ FTA*</div>
        <v-text-field
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.non_compliance_fta_number"
          maxLength="100"
          outlined
          dense
          hide-details
          disabled
        />
        <div v-else class="view-value">{{ supplierQuality.non_compliance_fta_number }}</div>
        <div class="error-msg" v-if="$v.supplierQuality.non_compliance_fta_number.$error">Renseignez le numéro de NC FTA</div>
      </v-col>

      <v-col cols="12" md="6">
        <div class="field-label">CONTACT FOURNISSEUR*</div>
        <v-text-field
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.contact"
          maxLength="100"
          outlined
          dense
          hide-details
        />
        <div v-else class="view-value">{{ supplierQuality.contact }}</div>
        <div class="error-msg" v-if="$v.supplierQuality.contact.$error">Renseignez le contact</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <div class="field-label">EMAIL FOURNISSEUR*</div>
        <v-text-field
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.email"
          maxLength="100"
          outlined
          dense
          hide-details
        />
        <div v-else class="view-value">{{ supplierQuality.email }}</div>
        <div class="error-msg" v-if="$v.supplierQuality.email.$error && !$v.supplierQuality.email.required">Renseignez l'email</div>
        <div class="error-msg"
          v-if="$v.supplierQuality.email.$error && $v.supplierQuality.email.required && !$v.supplierQuality.email.email"
        >Renseignez une adresse email valide</div>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12">
        <AddArticlesSupplierQuality
          :retour_a_articles="supplierQuality_a_articles"
          :mode="mode"
          title="SELECTIONNER UN PRODUIT"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="field-label">INDIQUER LE OU LES CODES DE PRODUCTION*</div>
        <v-textarea
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.code_production_comment"
          outlined
          dense
          hide-details
          rows="3"
        />
        <div v-else class="view-value">{{ supplierQuality.code_production_comment }}</div>
        <div class="error-msg" v-if="$v.supplierQuality.code_production_comment.$error">Renseignez le(s) code(s) de production</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="field-label">DESCRIPTION DU PROBLÈME RENCONTRÉ*</div>
        <v-textarea
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.description"
          outlined
          dense
          hide-details
          rows="3"
        />
        <div v-else class="view-value">{{ supplierQuality.description }}</div>
        <div class="error-msg" v-if="$v.supplierQuality.description.$error">Renseignez la description</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <div class="field-label">COÛT ESTIMÉ POUR FTA DE LA NC</div>
        <v-text-field
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.estimated_cost"
          maxLength="100"
          outlined
          dense
          hide-details
        />
        <div v-else class="view-value">{{ supplierQuality.estimated_cost }}</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="field-label">DESCRIPTION DU COÛT ESTIMÉ (MAIN D'OEUVRE, FRAIS DE PORT, FACTURE CLIENT)</div>
        <v-textarea
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.estimated_cost_description"
          outlined
          dense
          hide-details
          rows="3"
        />
        <div v-else class="view-value">{{ supplierQuality.estimated_cost_description }}</div>
      </v-col>
    </v-row>

    <v-row class="mt-1 mb-2">
      <v-col cols="12" class="text-center">
        <v-btn color="#FFA22C" dark :disabled="isCreationMode" @click="printNCDeclaration">
          <v-icon left>mdi-printer</v-icon>
          IMPRIMER LA DÉCLARATION DE NC
        </v-btn>
        <div v-if="isCreationMode" class="info-message mt-1">La non-conformité doit être créée avant l'impression</div>
      </v-col>
    </v-row>

    <!-- ══ RETOUR FOURNISSEUR ══════════════════════════════════════ -->
    <div class="section-header mt-8">RETOUR FOURNISSEUR</div>

    <v-row class="mt-3">
      <v-col cols="12" md="3">
        <v-checkbox
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.is_accepted"
          label="NC ACCEPTÉE PAR LE FOURNISSEUR"
          hide-details
          class="checkbox-field"
        />
        <div v-else>
          <div class="field-label">NC ACCEPTÉE PAR LE FOURNISSEUR</div>
          <div class="view-value" :class="supplierQuality.is_accepted ? 'text-success' : 'text-error'">
            {{ supplierQuality.is_accepted ? 'OUI' : 'NON' }}
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="3">
        <v-checkbox
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.need_return"
          label="MATÉRIEL À RETOURNER"
          hide-details
          class="checkbox-field"
        />
        <div v-else>
          <div class="field-label">MATÉRIEL À RETOURNER</div>
          <div class="view-value" :class="supplierQuality.need_return ? 'text-success' : 'text-error'">
            {{ supplierQuality.need_return ? 'OUI' : 'NON' }}
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="field-label">EN CAS DE REFUS, EXPLIQUEZ LES RAISONS</div>
        <v-textarea
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.refusal_reason"
          outlined
          dense
          hide-details
          rows="3"
        />
        <div v-else class="view-value">{{ supplierQuality.refusal_reason }}</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <div class="field-label">N° DE NON CONFORMITÉ FOURNISSEUR</div>
        <v-text-field
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.non_compliance_number"
          maxLength="100"
          outlined
          dense
          hide-details
        />
        <div v-else class="view-value">{{ supplierQuality.non_compliance_number }}</div>
      </v-col>

      <v-col cols="12" md="6">
        <div class="field-label">CONDITION DE LIVRAISON</div>
        <v-radio-group v-if="mode !== 'visualisation'" v-model="supplierQuality.delivery_type" hide-details class="mt-1">
          <v-radio label="Enlèvement fournisseur" value="enlevement fournisseur" />
          <v-radio label="Expédition par nos soins" value="expedition par nos soins" />
        </v-radio-group>
        <div v-else class="view-value">{{ supplierQuality.delivery_type }}</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <div class="field-label">DATE D'EXPÉDITION</div>
        <v-menu
          ref="menuShipping"
          v-model="menuShipping"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          light
        >
          <template v-slot:activator="{ on, attrs }">
            <div v-if="mode !== 'visualisation'" class="d-flex align-center">
              <v-text-field
                :value="formatShippingDate"
                dense
                readonly
                outlined
                hide-details
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              />
              <v-btn v-if="supplierQuality.shipping_date" @click.stop="clearShippingDate" icon small class="ml-1">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
            <div v-else class="view-value">{{ formatShippingDate }}</div>
          </template>
          <v-date-picker v-model="supplierQuality.shipping_date" no-title locale="fr-fr" @input="menuShipping = false" />
        </v-menu>
      </v-col>

      <v-col cols="12" md="6">
        <div class="field-label">INDIQUER TRANSPORTEUR</div>
        <v-text-field
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.carrier"
          maxLength="100"
          outlined
          dense
          hide-details
        />
        <div v-else class="view-value">{{ supplierQuality.carrier }}</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <div class="field-label">INDIQUER DIMENSIONS ET POIDS DU COLIS</div>
        <v-text-field
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.package_detail"
          maxLength="100"
          outlined
          dense
          hide-details
        />
        <div v-else class="view-value">{{ supplierQuality.package_detail }}</div>
      </v-col>
    </v-row>

    <v-row class="mt-1 mb-2">
      <v-col cols="12" class="text-center">
        <v-btn color="#FFA22C" dark :disabled="isCreationMode" @click="printDeliveryNote">
          <v-icon left>mdi-printer</v-icon>
          IMPRIMER BON DE LIVRAISON
        </v-btn>
        <div v-if="isCreationMode" class="info-message mt-1">La non-conformité doit être créée avant l'impression</div>
      </v-col>
    </v-row>

    <!-- ══ NON CONFORMITÉ CLOTURÉE ════════════════════════════════ -->
    <div class="section-header mt-8">NON CONFORMITÉ CLOTURÉE</div>

    <v-row class="mt-3">
      <v-col cols="12" md="4">
        <div class="field-label">STATUT</div>
        <v-select
          v-if="mode !== 'visualisation'"
          v-model="supplierQuality.status"
          :items="statusOptions"
          outlined
          dense
          hide-details
        />
        <div v-else class="view-value">{{ supplierQuality.status }}</div>
      </v-col>
    </v-row>

    <!-- ══ Save ════════════════════════════════════════════════════ -->
    <v-row v-if="mode !== 'visualisation'" class="mt-8 mb-6">
      <v-col cols="12" class="text-center">
        <v-btn color="#0B87BA" large dark rounded @click="submit">
          {{ mode === 'modification' ? 'MODIFIER' : 'ENREGISTRER' }}
        </v-btn>
      </v-col>
    </v-row>

    <Popup :dialog="errorDialog" :text="errorMessage" :actions="errorActions" @closeError="errorDialog = false" />
  </form>
</template>

<script>
import moment from "moment";
import { required, email } from "vuelidate/lib/validators";
import AddArticlesSupplierQuality from "@/components/Clients/AddArticlesSupplierQuality";
import Popup from "@/components/shared/Popup";
import apiSupplierQuality from "@/api/supplier_quality";

export default {
  name: "SupplierQualityForm",
  props: ["supplierQuality", "supplierQuality_a_articles", "mode"],
  components: { AddArticlesSupplierQuality, Popup },
  data() {
    return {
      menu: false,
      menuShipping: false,
      statusOptions: ["", "Refusée", "Materiel reparé", "Avoir accepté", "Matériel échangé"],
      errorDialog: false,
      errorMessage: "",
      errorActions: { actions: [{ btn: "OK", event: "closeError" }] },
    };
  },
  validations: {
    supplierQuality: {
      date: { required },
      supplier: { required },
      non_compliance_fta_number: { required },
      contact: { required },
      email: { required, email },
      code_production_comment: { required },
      description: { required },
    },
  },
  computed: {
    formatDate() {
      return this.supplierQuality.date ? moment(this.supplierQuality.date).format("DD/MM/YYYY") : "";
    },
    formatShippingDate() {
      return this.supplierQuality.shipping_date ? moment(this.supplierQuality.shipping_date).format("DD/MM/YYYY") : "";
    },
    isCreationMode() {
      return this.mode === 'creation' || !this.supplierQuality.id;
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("emitSupplierQuality", this.supplierQuality);
      }
    },
    clearShippingDate() {
      this.supplierQuality.shipping_date = null;
    },
    async printNCDeclaration() {
      if (this.isCreationMode) { return; }
      try {
        const response = await apiSupplierQuality.downloadNCDeclaration(this.supplierQuality.id);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `NC_Declaration_${this.supplierQuality.non_compliance_fta_number}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch {
        this.errorMessage = "Erreur lors du téléchargement de la déclaration de NC";
        this.errorDialog = true;
      }
    },
    async printDeliveryNote() {
      if (this.isCreationMode) { return; }
      try {
        const response = await apiSupplierQuality.downloadDeliveryNote(this.supplierQuality.id);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Bon_Livraison_${this.supplierQuality.non_compliance_fta_number}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch {
        this.errorMessage = "Erreur lors du téléchargement du bon de livraison";
        this.errorDialog = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.section-header {
  background-color: #0b87ba;
  color: #fff;
  padding: 7px 14px;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  margin-bottom: 4px;
}

.checkbox-field ::v-deep .v-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #777;
  letter-spacing: 0.04em;
}

.field-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #777;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.view-value {
  font-weight: 600;
  text-align: left;
  padding: 4px 0;
  min-height: 28px;
}

.error-msg {
  color: #e53935;
  font-size: 0.75rem;
  margin-top: 4px;
}

.text-success { color: #43a047; }
.text-error   { color: #e53935; }

.info-message {
  color: #999;
  font-size: 0.78rem;
  font-style: italic;
}
</style>
